import React, { useCallback, useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import UpdateIcon from "@mui/icons-material/Update";
import CircularProgress from "@mui/material/CircularProgress";
import DetailsCard from "./DetailsCard";
import MerchantNameIcon from "../../MerchantLoanRequests/icons/name.svg";
import AvatarIcon from "../../MerchantLoanRequests/icons/avatar.svg";
import HomeIcon from "../../MerchantLoanRequests/icons/home.svg";
import BipononGrayIcon from "../../MerchantLoanRequests/icons/biponon-gray.svg";
import MapIcon from "../../MerchantLoanRequests/icons/map-region.svg";
import EndSessionIcon from "../../../img/stop-circle.svg";
import RejectIcon from "../../MerchantLoanRequests/icons/reject.svg";
import ApproveIcon from "../../MerchantLoanRequests/icons/approve.svg";
import EditIcon from "../svg/edit.svg";
import SearchImage from "../images/Search.png";
import RequestImages from "./RequestImages";
import ApprovalHistory from "./ApprovalHistory";
import "../styles/modalStyle.scss";
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
const BankInclusionApprovalModalContent = ({
  requestData,
  loading = false,
  error = false,
  noRequestsAvailable = false,
  onClose,
  onReject,
  onSendBack,
  onApprove,
  isSessionMode = false,
  isProcessing = false,
  showL2FeedbackInitialValue = false,
  counts,
}) => {
  const userAlias = localStorage.getItem("alias") ?? null;

  const [showApprovalHistory, setShowApprovalHistory] = useState(false);
  const [showL2Feedback, setShowL2Feedback] = useState(
    showL2FeedbackInitialValue
  );
  const [editableRequestData, setEditableRequestData] = useState(
    requestData ? JSON.parse(JSON.stringify(requestData)) : null
  );

  useEffect(() => {
    if (requestData) {
      setEditableRequestData(JSON.parse(JSON.stringify(requestData)));
    }
  }, [requestData]);

  useEffect(() => {
    setShowL2Feedback(showL2FeedbackInitialValue);
  }, [showL2FeedbackInitialValue]);

  const localUserType = JSON.parse(localStorage.getItem("currUserType"));
  const canApproveReject = ["cs_user_layer_1", "cs_user_layer_2"].includes(
    localUserType
  );

  const editableRequestFields = [
    "Bank Account Holder's Name (Shop Owner/Merchant name)",
    "Bank Account Number",
    "MICR Line Number",
  ];

  const editableMerchantFields = [
    // "bKash Wallet Number",
    // "Details Address",
    // "Shop Owner",
  ];

  const handleActionClick = useCallback(
    (action) => {
      if (isProcessing) return;

      if (action === "reject" && onReject) {
        onReject();
      } else if (action === "recommend" && onApprove) {
        onApprove(editableRequestData || requestData);
      } else if (action === "send_back" && onSendBack) {
        onSendBack();
      }
    },
    [
      onReject,
      onApprove,
      onSendBack,
      editableRequestData,
      requestData,
      isProcessing,
    ]
  );

  const handleFieldEdit = useCallback(
    (cardType, fieldLabel, newValue, newSubValue) => {
      setEditableRequestData((prev) => {
        const updated = { ...prev };

        if (cardType === "request") {
          switch (fieldLabel) {
            case "Bank Account Holder's Name (Shop Owner/Merchant name)":
              updated.request_details.account_holder_name = newValue;
              break;
            case "Bank Account Number":
              updated.request_details.account_number = newValue;
              break;
            case "MICR Line Number":
              updated.request_details.micr_line_number = newValue;
              break;
            default:
              break;
          }
        } else if (cardType === "merchant") {
          switch (fieldLabel) {
            case "bKash Wallet Number":
              updated.merchant_details.merchant_wallet = newValue;
              break;
            case "Details Address":
              updated.merchant_details.address = newValue;
              break;
            case "Shop Owner":
              updated.merchant_details.owner_name = newValue;
              if (newSubValue) {
                updated.merchant_details.owner_phone = newSubValue;
              }
              break;
            default:
              break;
          }
        }

        return updated;
      });
    },
    []
  );

  const currentData = editableRequestData || requestData;

  if (noRequestsAvailable) {
    return (
      <div className="bank-inclusion-details-modal-overlay">
        <div className="bank-inclusion-details-modal">
          <div className="bank-inclusion-details-modal__header">
            <h2 className="bank-inclusion-details-modal__title">
              Merchant Bank Inclusion Request
            </h2>
          </div>
          <div className="bank-inclusion-details-modal__content">
            <div
              className="error-container"
              style={{
                minHeight: "60vh",
              }}
            >
              <img src={SearchImage} alt="" className="error-image" />
              <h2 className="error-title">No more requests available</h2>
              <p className="error-message">
                Please end session and try again later
              </p>
            </div>
          </div>
          <div className="bank-inclusion-details-modal__footer">
            {canApproveReject && (
              <button
                className="end-session-button"
                onClick={onClose}
                disabled={isProcessing}
              >
                <img
                  src={EndSessionIcon}
                  alt="End Session"
                  className="btn--icon"
                />
                End Session
              </button>
            )}
            {isSessionMode && canApproveReject && (
              <div className="session-counts">
                <div className="count-item">
                  <span className="count-label">Total:</span>
                  <span className="count-value">{counts?.total || 0}</span>
                </div>
                <div className="count-item">
                  <span className="count-label">Approved:</span>
                  <span className="count-value">{counts?.approved || 0}</span>
                </div>
                {localUserType === "cs_user_layer_2" && (
                  <div className="count-item">
                    <span className="count-label">Sent Back to L1:</span>
                    <span className="count-value">
                      {counts?.sent_back || 0}
                    </span>
                  </div>
                )}
                <div className="count-item">
                  <span className="count-label">Rejected:</span>
                  <span className="count-value">{counts?.rejected || 0}</span>
                </div>
              </div>
            )}
            <div></div>
          </div>
        </div>
      </div>
    );
  }

  if (loading || (!requestData && !error)) {
    return (
      <div className="bank-inclusion-details-modal-overlay">
        <div className="bank-inclusion-details-modal">
          <div className="bank-inclusion-details-modal__header">
            <h2 className="bank-inclusion-details-modal__title">
              Loading Bank Inclusion Request...
            </h2>
          </div>
          <div className="bank-inclusion-details-modal__content">
            <div
              style={{
                minHeight: "60vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress size={60} thickness={4} />
            </div>
          </div>
          <div className="bank-inclusion-details-modal__footer">
            {canApproveReject && (
              <button
                className="end-session-button"
                onClick={onClose}
                disabled={isProcessing}
              >
                <img
                  src={EndSessionIcon}
                  alt="End Session"
                  className="btn--icon"
                />
                End Session
              </button>
            )}
            {isSessionMode && canApproveReject && (
              <div className="session-counts">
                <div className="count-item">
                  <span className="count-label">Total:</span>
                  <span className="count-value">{counts?.total || 0}</span>
                </div>
                <div className="count-item">
                  <span className="count-label">Approved:</span>
                  <span className="count-value">{counts?.approved || 0}</span>
                </div>
                {localUserType === "cs_user_layer_2" && (
                  <div className="count-item">
                    <span className="count-label">Sent Back to L1:</span>
                    <span className="count-value">
                      {counts?.sent_back || 0}
                    </span>
                  </div>
                )}
                <div className="count-item">
                  <span className="count-label">Rejected:</span>
                  <span className="count-value">{counts?.rejected || 0}</span>
                </div>
              </div>
            )}
            {isSessionMode && canApproveReject && (
              <div className="action-buttons">
                <button className="btn btn--reject" disabled>
                  <img src={RejectIcon} alt="Reject" className="btn--icon" />
                  Reject
                </button>
                {localUserType === "cs_user_layer_2" && (
                  <button className="btn btn--reject" disabled>
                    <img
                      src={RejectIcon}
                      alt="Send Back to L1"
                      className="btn--icon"
                    />
                    Send Back to L1
                  </button>
                )}
                <button className="btn btn--recommend" disabled>
                  <img src={ApproveIcon} alt="Accept" className="btn--icon" />
                  Accept
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  const requestDetailsItems = [
    {
      label: "Bank Inclusion Request ID",
      value: currentData?.request_details?.request_id || "N/A",
      icon: BipononGrayIcon,
    },
    {
      label: "Bank Name",
      value: currentData?.request_details?.bank_name || "N/A",
      icon: BipononGrayIcon,
    },
    {
      label: "Branch Name",
      value: currentData?.request_details?.branch_name || "N/A",
      icon: BipononGrayIcon,
    },
    {
      label: "Bank Routing Number",
      value: currentData?.request_details?.bank_routing_number || "N/A",
      icon: BipononGrayIcon,
    },
    {
      label: "Bank Account Holder's Name (Shop Owner/Merchant name)",
      value: currentData?.request_details?.account_holder_name || "N/A",
      icon: BipononGrayIcon,
    },
    {
      label: "Bank Account Number",
      value: currentData?.request_details?.account_number || "N/A",
      icon: MapIcon,
    },
    {
      label: "MICR Line Number",
      value: currentData?.request_details?.micr_line_number || "N/A",
      icon: MapIcon,
    },
  ].filter((item) => !(canApproveReject && item.label === "MICR Line Number"));

  const merchantInformation = [
    {
      label: "Outlet Name",
      value: currentData?.merchant_details?.merchant_name || "N/A",
      icon: MerchantNameIcon,
    },
    {
      label: "bKash Wallet Number",
      value: currentData?.merchant_details?.merchant_wallet || "N/A",
      copyable: true,
      icon: AvatarIcon,
    },
    {
      label: "Details Address",
      value: currentData?.merchant_details?.address || "N/A",
      icon: HomeIcon,
    },
    {
      label: "Shop Owner",
      value: currentData?.merchant_details?.owner_name || "N/A",
      subValue: currentData?.merchant_details?.owner_phone || "N/A",
      icon: HomeIcon,
    },
    {
      label: "Registration Date",
      value: currentData?.merchant_details?.reg_date || "N/A",
      subValue: currentData?.merchant_details?.reg_tenure || "N/A",
      icon: AvatarIcon,
    },
    {
      label: "Product Type",
      value: currentData?.merchant_details?.merchant_type || "N/A",
      icon: HomeIcon,
    },
    {
      label: "MDO Info",
      avatar: currentData?.merchant_details?.requested_by?.avatar || null,
      value: currentData?.merchant_details?.requested_by?.name || "N/A",
      subValue:
        currentData?.merchant_details?.requested_by?.whitelisting_number ||
        "N/A",
      icon: HomeIcon,
      extraInfo:
        currentData?.merchant_details?.requested_by?.joining_tenure || "N/A",
    },
  ];

  const imageTabs = [
    {
      label: "Bank Inclusion Form And Cheque Book Images",
      value: "bank_inclusion_form",
      images: [
        {
          label: "Bank Inclusion Form Image",
          src: currentData?.request_details?.bank_inclusion_form_image || null,
          canZoom: true,
          canRotate: true,
        },
        {
          label: "Check Book Image",
          src: currentData?.request_details?.check_book_image || null,
          canZoom: true,
          canRotate: true,
        },
      ],
    },
    {
      label: "Shop Owner/Merchant Image & Outlet Image",
      value: "shop_owner_merchant_image",
      images: [
        {
          label: "Shop Owner/Merchant Image",
          src: currentData?.merchant_details?.owner_image || null,
          canZoom: true,
          canRotate: true,
        },
        {
          label: "Outlet Image",
          src: currentData?.merchant_details?.outlet_image || null,
          canZoom: true,
          canRotate: true,
        },
      ],
    },
  ];

  const bankInfoId =
    requestData?.bank_info_id ||
    requestData?.request_details?.bank_info_id ||
    requestData?.request_details?.request_id;

  const handleApprovalHistoryClick = () => {
    setShowApprovalHistory((prev) => !prev);
  };

  const handleL2FeedbackClick = () => {
    setShowL2Feedback((prev) => !prev);
  };

  return (
    <div className="bank-inclusion-details-modal-overlay">
      <div className="bank-inclusion-details-modal">
        <div className="bank-inclusion-details-modal__header">
          <h2 className="bank-inclusion-details-modal__title">
            {loading
              ? "Loading request details..."
              : `Approve/reject migration request for ${
                  currentData?.merchant_details?.merchant_name ||
                  "Unknown Merchant"
                }`}
            {canApproveReject && userAlias && (
              <span className="username">
                {" "}
                (being reviewed by{" "}
                {capitalizeFirstLetter(JSON.parse(userAlias))})
              </span>
            )}
          </h2>
          <div className="bank-inclusion-details-modal__stats">
            {localUserType === "cs_user_layer_1" && (
              <button
                className="approval-history-button"
                onClick={handleL2FeedbackClick}
              >
                <img
                  src={EditIcon}
                  alt="L2 Feedback"
                  style={{ height: "24px", width: "24px" }}
                />
                <span>View L2 Feedback</span>
              </button>
            )}
            <button
              className="approval-history-button"
              onClick={handleApprovalHistoryClick}
            >
              <UpdateIcon style={{ height: "24px", width: "24px" }} />
              <span>View Approval History</span>
            </button>
          </div>
          {!isSessionMode && (
            <button
              className="bank-inclusion-details-modal__close"
              onClick={onClose}
            >
              <CloseIcon size={20} />
            </button>
          )}
        </div>

        <div className="bank-inclusion-details-modal__content">
          <div className="request-content-grid">
            <div className="request-info-container">
              <DetailsCard
                title="Request Information"
                dataArray={requestDetailsItems}
                loading={loading}
                error={error}
                editable={isSessionMode}
                editableFields={editableRequestFields}
                onEdit={(label, value, subValue) =>
                  handleFieldEdit("request", label, value, subValue)
                }
              />
              <DetailsCard
                title="Merchant Information"
                dataArray={merchantInformation}
                loading={loading}
                error={error}
                editable={isSessionMode}
                editableFields={editableMerchantFields}
                onEdit={(label, value, subValue) =>
                  handleFieldEdit("merchant", label, value, subValue)
                }
              />
            </div>
            <div className="request-image-container">
              <RequestImages
                imageTabs={imageTabs}
                loading={loading}
                error={error}
              />
            </div>
          </div>
        </div>

        <div className="bank-inclusion-details-modal__footer">
          {isSessionMode && (
            <button
              className="end-session-button"
              onClick={onClose}
              disabled={isProcessing}
            >
              <img
                src={EndSessionIcon}
                alt="End Session"
                className="btn--icon"
              />
              End Session
            </button>
          )}
          {isSessionMode && canApproveReject && (
            <div className="session-counts">
              <div className="count-item">
                <span className="count-label">Total:</span>
                <span className="count-value">{counts.total}</span>
              </div>
              <div className="count-item">
                <span className="count-label">Approved:</span>
                <span className="count-value">{counts.approved}</span>
              </div>
              {localUserType === "cs_user_layer_2" && (
                <div className="count-item">
                  <span className="count-label">Sent Back to L1:</span>
                  <span className="count-value">{counts.sent_back}</span>
                </div>
              )}
              <div className="count-item">
                <span className="count-label">Rejected:</span>
                <span className="count-value">{counts.rejected}</span>
              </div>
            </div>
          )}
          {isSessionMode && canApproveReject && (
            <>
              {/* <div className="keyboard-hint">
                <p className="keyboard-hint-text">
                  {isProcessing
                    ? "Processing..."
                    : 'Press "Space" to approve or "Ctrl" to reject requests.'}
                </p>
              </div> */}
              <div className="action-buttons">
                <button
                  className="btn btn--reject"
                  onClick={() => handleActionClick("reject")}
                  disabled={isProcessing}
                >
                  <img src={RejectIcon} alt="Reject" className="btn--icon" />
                  {isProcessing ? "Processing..." : "Reject"}
                </button>
                {localUserType === "cs_user_layer_2" && (
                  <button
                    className="btn btn--correction"
                    onClick={() => handleActionClick("send_back")}
                    disabled={isProcessing}
                  >
                    <img
                      src={RejectIcon}
                      alt="Send Back to L1"
                      className="btn--icon"
                    />
                    {isProcessing ? "Processing..." : "Send Back to L1"}
                  </button>
                )}
                <button
                  className="btn btn--recommend"
                  onClick={() => handleActionClick("recommend")}
                  disabled={isProcessing}
                >
                  <img src={ApproveIcon} alt="Accept" className="btn--icon" />
                  {isProcessing ? "Processing..." : "Accept"}
                </button>
              </div>
            </>
          )}
        </div>

        <ApprovalHistory
          isVisible={showApprovalHistory}
          onClose={() => setShowApprovalHistory(false)}
          loading={false}
          title="Approval History"
          style={{ right: "240px" }}
          bankInfoId={bankInfoId}
        />

        <ApprovalHistory
          isVisible={showL2Feedback}
          onClose={() => setShowL2Feedback(false)}
          loading={false}
          title="L2 Feedback"
          style={{ right: "400px" }}
          bankInfoId={bankInfoId}
        />
      </div>
    </div>
  );
};

export default BankInclusionApprovalModalContent;
